const Dashboard = () => {
  return (
    <div>
      <div className="flex justify-between mb-6">
        <div className="flex flex-col">
          <span className="font-semibold sm:text-md md:text-lg text-sm">
            Welcome {localStorage.getItem("name") || ""}!
          </span>
        </div>
        <div>
        </div>
      </div>

      <div
        className="grid grid-cols-12 gap-6 min-h-[400px]"
        id="dashboard-container"
      >
      </div>    
    </div>
  );
};

export default Dashboard;
